// src/pages/BookingContext.js
import React, { createContext, useState, useEffect } from 'react';

// ✅ Create context
export const BookingContext = createContext();

// ✅ Export provider
export const BookingProvider = ({ children }) => {
  // Load dates from localStorage on mount
  const [selectedRooms, setSelectedRooms] = useState(() => {
    const saved = localStorage.getItem('damtua_selectedRooms');
    return saved ? JSON.parse(saved) : [];
  });

  const [bookingDates, setBookingDates] = useState(() => {
    const saved = localStorage.getItem('damtua_bookingDates');
    return saved ? JSON.parse(saved) : { checkIn: '', checkOut: '' };
  });

  // Save selectedRooms to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('damtua_selectedRooms', JSON.stringify(selectedRooms));
  }, [selectedRooms]);

  // Save bookingDates to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('damtua_bookingDates', JSON.stringify(bookingDates));
  }, [bookingDates]);

  const addRoom = (room) => {
    setSelectedRooms((prev) => [...prev, room]);
  };

  const removeRoom = (roomId) => {
    setSelectedRooms((prev) => {
      const index = prev.findIndex(r => r.id === roomId);
      if (index !== -1) {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      }
      return prev;
    });
  };

  const clearRooms = () => {
    setSelectedRooms([]);
  };

  const setDates = (checkIn, checkOut) => {
    setBookingDates({ checkIn: checkIn || '', checkOut: checkOut || '' });
  };

  const clearDates = () => {
    setBookingDates({ checkIn: '', checkOut: '' });
  };

  const clearAll = () => {
    clearRooms();
    clearDates();
  };

  return (
    <BookingContext.Provider value={{ 
      selectedRooms, 
      addRoom, 
      removeRoom, 
      clearRooms,
      bookingDates,
      setDates,
      clearDates,
      clearAll
    }}>
      {children}
    </BookingContext.Provider>
  );
};